import React from 'react';
import { Grid, Row, Col } from 'react-bootstrap';
import Menu from './restaurants/Menu';
import VenuesCardsSlider from './restaurants/VenuesCardsSlider';
import BestFriend from './shared/BestFriend';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { customerJourneyMenu, customerJourneyVenues } from './../../actions';

const restaurantsBannerImage = require('./../../images/restaurants_banner.jpg');

import './restaurants.scss';

class Restaurants extends React.Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.actions.customerJourneyMenu(this.props.token, this.props.currentLanguage, this.props.context);
    this.props.actions.customerJourneyVenues(this.props.token, this.props.currentLanguage, this.props.context);
  }

  render() {

    const bannerImageStyle = {backgroundImage: `url(${restaurantsBannerImage})`};

    return (
      <Grid className="restaurants-component">

        <Row className="restaurants-banner">
          <div className="restaurants-banner__image-holder" style={bannerImageStyle}>

            <div className="restaurants-banner__overlay"></div>

            <Col sm={6}>
              <div className="restaurants-banner__text-holder">
                <div>
                  <h4>{this.props.translate('restaurants.header')}</h4>

                  <div className="restaurants-banner__text">
                    <h3>
                      {this.props.translate('restaurants.title')}
                    </h3>
                    <br/>
                    <h5>{this.props.translate('restaurants.text')}<strong>{this.props.hotel.apiData.name}</strong></h5>
                  </div>
                </div>
              </div>
            </Col>

          </div>
        </Row>

        <Menu/>
        <br/>

        <VenuesCardsSlider/>
        <br/>

        <BestFriend/>

      </Grid>
    );
  }
}

Restaurants.displayName = 'PagesRestaurants';
Restaurants.propTypes = {};
Restaurants.defaultProps = {};

const mapStateToProps = (state) => {
  return { 
      translate: getTranslate(state.locale),
      currentLanguage: getActiveLanguage(state.locale).code,
      token: state.commons.token,
      context: state.commons.context,
      hotel: state.hotel
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      customerJourneyMenu: bindActionCreators(customerJourneyMenu, dispatch),
      customerJourneyVenues: bindActionCreators(customerJourneyVenues, dispatch)
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Restaurants);



// WEBPACK FOOTER //
// ./components/pages/Restaurants.js